<script setup>
import { computed, ref } from "vue";
import VueEasyLightbox from 'vue-easy-lightbox'

const props = defineProps({
    image: Object,
    autoAspectRatio: {
        types: [Boolean],
        default: true
    },
    cover: {
        types: [Boolean],
        default: false
    },
    lightBox: {
        types: [Boolean],
        default: false
    },
});

const style = computed(() => {
    if(!props.autoAspectRatio){
        return null;
    }

    return {
        aspectRatio: `${props.image.width}/${props.image.height}`,
    };
});

const isLightboxVisible = ref(false)
</script>

<template>
    <div
        @click="isLightboxVisible = true"
        class="relative"
        :style="style"
        :class="props.lightBox ? 'cursor-pointer' : ''"
    >
        <img
            class="absolute left-0 top-0 size-full"
            :class="props.cover ? 'object-cover' : 'object-contain'"
            :src="props.image.src" 
        />
        <vue-easy-lightbox
            :visible="isLightboxVisible"
            v-if="props.lightBox"
            :imgs="props.image.lightboxSrc"
            :index="0"
            :zoom-scale="0.5"
            teleport="body"
            @hide="isLightboxVisible = false"
        ></vue-easy-lightbox>
    </div>
</template>
